var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"service-ticket-parts.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"service_ticket_parts.all_service_ticket_parts\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"service-ticket-parts.create\">\n<a translate=\"service_ticket_parts.create_service_ticket_parts\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="service_ticket_parts.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/service_ticket_parts/service_ticket_parts.html
// module id = 2785
// module chunks = 1